<template>
  <div class="ankang-scan">
    <div class="page-content">
      <img class="top-card" src="/static/images/ankang/vip.png" alt="秦岭高山凰" />

      <div class="section-title">点击下方图标，扫描溯源二维码</div>

      <div class="scan-box" @click="handleScan">
        <img class="scan-icon" src="/static/images/ankang/scan.png" alt="扫码" />
      </div>

      <div class="section-title manual-title">手动输入溯源编号查询</div>

      <div class="query-bar">
        <input
          v-model.trim="traceCode"
          class="query-input"
          type="text"
          maxlength="16"
          inputmode="numeric"
          placeholder="请输入包装上的溯源编号"
        />
        <button class="query-btn" type="button" @click="handleQuery">立即查询</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'AnKangScan',
  data() {
    return {
      appId: 'wx885161c495be58a3',
      eno: process.env.ENV_NUM === '1' ? '138954451688' : '138152001162',
      traceCode: '',
      wxReady: false
    }
  },
  mounted() {
    this.initWxJs()
  },
  methods: {
    handleScan() {
      if (!this.wxReady) {
        alert('微信扫码能力初始化中，请稍后重试')
        return
      }
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrCode'],
        success: res => {
          const scanResult = res.resultStr || ''
          let scanQRCode = scanResult
          if (scanResult.startsWith('http') && scanResult.includes('/?')) {
            const parts = scanResult.split('/?')
            scanQRCode = parts.length > 1 ? parts[1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          if (!/^\d{16}$/.test(scanQRCode)) {
            alert('请扫描正确的溯源码')
            return
          }
          this.traceCode = scanQRCode
          this.validateAndGo(scanQRCode)
        },
        fail: () => {
          alert('打开摄像头失败，请稍后重试')
        }
      })
    },
    async handleQuery() {
      const inputValue = this.traceCode.trim()
      if (!inputValue) {
        alert('请输入16位溯源编号')
        return
      }
      if (!/^\d{16}$/.test(inputValue)) {
        alert('请输入16位纯数字溯源编号')
        return
      }
      await this.validateAndGo(inputValue)
    },
    goToResult(code, firstQueryTime, preQueryTime) {
      return `/ankang?code=${encodeURIComponent(code)}&firstQueryTime=${encodeURIComponent(firstQueryTime || '')}&preQueryTime=${encodeURIComponent(preQueryTime || '')}`
    },
    async validateAndGo(code) {
      if (!/^\d{16}$/.test(code)) {
        alert('请输入16位纯数字溯源编号')
        return
      }
      try {
        const res = await getAntiData(code, this.eno)
        const data = res.data
        if (data == null || data.code == '500') {
          alert('查询异常，请重新输入防伪码进行查询')
          return
        }
        if (data.code === '300101' || data.code === '300102') {
          const firstQueryTime = data.data && data.data.firstQueryTime ? data.data.firstQueryTime : ''
          const preQueryTime = data.data && data.data.preQueryTime ? data.data.preQueryTime : ''
          window.location.href = this.goToResult(code, firstQueryTime, preQueryTime)
          return
        }
        if (data.code === '300106') {
          alert('此码不存在，谨防仿冒')
          return
        }
        alert(data.message || '查询结果异常，请稍后重试')
      } catch (e) {
        alert('查询异常，请稍后重试')
      }
    },
    initWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'scanQRCode',
            'hideMenuItems'
          ]
        })
        wx.ready(() => {
          this.wxReady = true
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
        wx.error(() => {
          this.wxReady = false
        })
      }).catch(() => {
        this.wxReady = false
        alert('获取微信授权失败，请稍后重试')
      })
    }
  }
}
</script>

<style scoped>
.ankang-scan {
  width: 100vw;
  min-height: 100vh;
  background: url(/static/images/ankang/bg.png) center top / 100% 100% no-repeat;
}

.page-content {
  min-height: 100vh;
  padding: 4.5vh 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.top-card {
  width: 90vw;
  max-width: 360px;
  display: block;
}

.section-title {
  margin-top: 5.2vh;
  font-size: 4.6vw;
  line-height: 1.35;
  font-weight: 700;
  color: #111111;
  text-align: center;
}

.scan-box {
  width: 24.8vw;
  height: 24.8vw;
  max-width: 99px;
  max-height: 99px;
  margin-top: 2.6vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scan-icon {
  width: 100%;
  height: 100%;
  display: block;
}

.manual-title {
  margin-top: 5.8vh;
}

.query-bar {
  width: 80vw;
  max-width: 320px;
  height: 5.9vh;
  min-height: 45px;
  margin-top: 2.1vh;
  display: flex;
  align-items: center;
}

.query-input {
  flex: 1;
  min-width: 0;
  height: 5.1vh;
  min-height: 40px;
  padding: 0 4vw;
  border: 1px solid #ccbfa9;
  border-right: 0;
  border-radius: 10px 0 0 10px;
  background: rgba(255, 255, 255, 0.32);
  font-size: 4vw;
  color: #333333;
  outline: none;
}

.query-input::placeholder {
  color: #bcbcbc;
}

.query-btn {
  width: 20.5vw;
  min-width: 82px;
  height: 5.9vh;
  min-height: 45px;
  border: 0;
  border-radius: 0 10px 10px 0;
  background: rgb(179, 155, 119);
  font-size: 4vw;
  font-weight: 700;
  color: #ffffff;
  padding: 0;
}

@media screen and (max-width: 350px) {
  .page-content {
    padding-top: 4vh;
  }

  .top-card {
    width: 77vw;
  }

  .section-title {
    font-size: 4.8vw;
  }

  .scan-box {
    width: 25vw;
    height: 25vw;
  }

  .query-bar {
    width: 80vw;
    min-height: 42px;
  }

  .query-input {
    min-height: 38px;
  }

  .query-btn {
    min-height: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnKang/Scan.vue